import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LangContext = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("fm.lang") || "ar");

    useEffect(() => {
        localStorage.setItem("fm.lang", lang);
        document.documentElement.setAttribute("lang", lang);
        document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
    }, [lang]);

    const t = useCallback((key) => translations[lang][key] ?? key, [lang]);
    const value = useMemo(() => ({ lang, setLang, t, isRtl: lang === "ar" }), [lang, t]);
    return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
    const ctx = useContext(LangContext);
    if (!ctx) throw new Error("useLang must be inside LangProvider");
    return ctx;
}
